import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { GuidelinesContainer } from './guidelines-container';
import { ProfileEditorContainer } from 'app/common/views/profile-editor-container';

export const SpecializedMentor: React.FC = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.path}>
        <Redirect to={`${match.path}/guidelines`} />
      </Route>
      <Route path={`${match.path}/apply`}>
        <ProfileEditorContainer />
      </Route>
      <Route path={`${match.path}/guidelines`}>
        <GuidelinesContainer />
      </Route>
      <Route path={`${match.path}/update`}>
        <ProfileEditorContainer />
      </Route>
    </Switch>
  );
};
